import React, { useEffect, useState } from 'react';
import Header from '../../../Components/Layout/Header';
import Playersidebar from '../Layout/Playersidebar';
import MyNFT from '../Pages/MyNFT';
import MyDNA from '../Pages/MyDNA/MyDNA';
import '../Styles/Playerdashboard.css';
import Nutrition from '../Pages/Nutrition/Nutrition';
import axios from 'axios';
import { SERVER_URL } from '../../../config';
import Nutrition_Panel from '../../NutritionPanel/Pages/Nutrition_Panel';

export default function PlayerDashboard() {
    const [isActive, setActive] = useState("div1");

    const [dietReportData, setDeitReportData] = useState(null);
    const [soccerReportData, setSoccerReportData] = useState(null);

    const token = sessionStorage.getItem('player_token');

    useEffect(() => {
        const fetchDietReport = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}/api/v2/get-user-diet-report`, {
                    headers: { Authorization: `Bearer ${token}`, }
                });
                if (response.data.status) {
                    setDeitReportData(response.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch diet report.", err);
            }
        };

        const fetchSoccerReport = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}/api/v2/get-user-soccer-report`, {
                    headers: { Authorization: `Bearer ${token}`, }
                });
                if (response.data.status) {
                    setSoccerReportData(response.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch soccer report.", err);
            }
        };


        fetchDietReport();
        fetchSoccerReport();
    }, []);

    return (
        <div className='min-h-screen bg-cover flex flex-col text-white w-full' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
            <div className='h-[90px]'>
                <Header />
            </div>
            <div className='flex flex-1 flex-col lg:flex-row'>
                <div className='hidden lg:block Player-sidebar-content Player-sidebar'>
                    <Playersidebar isActive={isActive} setActive={setActive} />
                </div>
                <div className='lg:hidden block'>
                    <Playersidebar isActive={isActive} setActive={setActive} />
                </div>
                <div className='Player-dashboard-content flex flex-grow w-full'>
                    {isActive === 'div1' && <MyNFT />}
                    {isActive === 'div2' && <MyDNA soccerReportData={soccerReportData} />}
                    {isActive === 'div3' && <Nutrition_Panel dietReportData={dietReportData} />}

                </div>
            </div>
        </div>
    );
}
